import React, { useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogClose,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ContractForm, useBearStore } from "@/section/otc/ContractForm";
import { useListAccounts } from "@/lib/api/otc";
import { useListCustomers } from "@/lib/api/customer";

export function ContractPreviewDialog({ 
    isOpen, 
    onClose, 
    contract 
}: { 
    isOpen: boolean; 
    onClose: () => void; 
    contract: any;
}) {
    const listAccountsRes = useListAccounts(false);
    const listCustomersRes = useListCustomers({ minimal: true, hasRiskProfile: true });
    const set_edit_contract = useBearStore((state) => state.set_edit_contract);
    
    useEffect(() => {
        if (isOpen && contract) {
            set_edit_contract(contract);
        }
        
        return () => {
            if (!isOpen) {
                set_edit_contract(undefined);
            }
        };
    }, [isOpen, contract, set_edit_contract]);
    
    if (!contract) return null;
    
    const accounts = listAccountsRes?.data?.data || [];
    const customers = listCustomersRes?.data?.data || [];
    
    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="max-w-screen-2xl md:min-w-sm lg:min-w-md xl:mg-w-lg">
                <DialogHeader>
                    <DialogTitle>Contract Details - {contract.contract_no}</DialogTitle>
                    <DialogDescription>
                        Viewing OTC contract in read-only mode
                    </DialogDescription>
                </DialogHeader>
                
                <ContractForm
                    isPreviewOnly={true}
                    accounts={accounts}
                    customers={customers}
                    isUpdateForm={true}
                    onEditField={() => {}}
                    onSubmit={async () => false}
                />
            </DialogContent>
        </Dialog>
    );
}
